import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../maintenance/Maintenance.css";

import Component1 from "../service_common_components/component1/Component1";
import Component2 from "../service_common_components/component2/Component2";
import Component3 from "../service_common_components/component3/Component3";

const Body_Repair = () => {
  return (
    <section className="Body_Repair service">
      <Container>
        <h4 className="service_title">Body Repair & Painting</h4>

      
        <Component1
          title1={"Comprehensive Car"}
          title2={"Care"}
          title3={
            "At our Body Repair & Painting facility, we specialize in restoring vehicles to their original condition — combining advanced technology, skilled craftsmanship, and premium materials to deliver exceptional results. Whether it’s minor dents, scratches, collision damage, or complete body refinishing, our expert technicians ensure every job meets the highest standards of quality and precision. Using state-of-the-art equipment and color-matching systems, we provide flawless paint finishes that blend seamlessly with your vehicle’s original shade. Our repair process includes careful surface preparation, precision body alignment, rust treatment, and durable paint protection to ensure a long-lasting, showroom-quality finish.We handle every vehicle with care — from inspection to final detailing — ensuring safety, durability, and aesthetic excellence. With our commitment to precision, quality materials, and professional service, we make your vehicle look and feel as good as new."
          }
          imgSrc={"/assets/images/services/body_repair.png"}
        />

   
        <Component2
          title="Our Repair & Painting Process"
          tips={[
            "Inspect the vehicle to ensure repairs and painting meet quality standards.",
            "Allow the paint to properly dry and cure for durability and shine.",
            "Fix dents, scratches, or structural damages using professional tools and techniques.",
            "Clean, sand, and prepare the damaged areas to ensure proper paint adhesion.",
            "Provide an accurate cost and time estimate for the required work."
          ]}
          list={true}
        />

        
        <Component2
          title="Benefits of Professional Body Care"
          tips={[
            "Provide a detailed estimate of costs and time required for the repairs.",
            "Apply high-quality paint, primers, and protective coatings for a flawless finish.",
            "Allow sufficient time for paint to dry and cure, ensuring durability and shine.",
            "Fix dents, scratches, or structural damages using professional-grade tools and techniques.",
            "Clean, sand, and prepare the damaged areas to ensure proper adhesion of paint and coatings."
          ]}
          list={true}
        />

        
        <Component3
          title="Maintenance Tips"
          tips={[
            "Regularly wash and wax to prevent scratches and paint fading.",
            "Park in shaded areas to protect from sun damage.",
            "Address dents and scratches early to prevent rust.",
          ]}
          list={true}
        />
      </Container>
    </section>
  );
};

export default Body_Repair;
